import React, { useState } from "react";
import { Linkedin, Instagram, Mail } from "react-feather";

const Contact = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitStatus, setSubmitStatus] = useState(null);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsSubmitting(true);
		setSubmitStatus(null);

		try {
			// Formspree integration
			const formData = new FormData(e.target);
			const response = await fetch("https://formspree.io/f/xblkvrpq", {
				method: "POST",
				body: formData,
				headers: {
					Accept: "application/json",
				},
			});

			if (response.ok) {
				setSubmitStatus("success");
				e.target.reset();

				setTimeout(() => setSubmitStatus(null), 3000);
			} else {
				throw new Error("Failed to send message");
			}
		} catch (error) {
			setSubmitStatus("error");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<section
			id="contact"
			className="relative py-16 lg:py-20 px-6 overflow-hidden"
		>
			{/* Background Image */}
			<div className="absolute inset-0 z-0">
				<img
					src="/assets/images/Swift-Group.JPG"
					alt="Swift Group Background"
					className="w-full h-full object-cover"
				/>
				{/* Overlay for better text readability */}
				<div className="absolute inset-0 bg-black/70"></div>
			</div>

			<div className="container relative z-10">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
					{/* Left Column - Navigation Links */}
					<div className="flex items-center h-full">
						<div className="text-white text-2xl lg:text-3xl font-light hover:text-swift-pink transition-colors duration-200 cursor-pointer font-generalSans">
							<div>Get in touch</div>
							<div className="text-5xl lg:text-6xl">With Us</div>

							{/* Social Media Icons */}
							<div className="flex space-x-4 mt-8">
								<a
									href="https://www.linkedin.com/company/swift-haven123/posts/?feedView=all"
									target="_blank"
									rel="noopener noreferrer"
									className="text-white hover:text-swift-pink transition-colors duration-200"
								>
									<Linkedin className="w-5 h-5" />
								</a>
								<a
									href="https://www.instagram.com/swifthaven_/"
									target="_blank"
									rel="noopener noreferrer"
									className="text-white hover:text-swift-pink transition-colors duration-200"
								>
									<Instagram className="w-5 h-5" />
								</a>
								<a
									href="mailto:info.swifthaven@gmail.com"
									className="text-white hover:text-swift-pink transition-colors duration-200"
								>
									<Mail className="w-5 h-5" />
								</a>
							</div>

							{/* Horizontal Line */}
							<div className="w-32 h-px bg-gray-600 mt-6"></div>

							{/* Copyright */}
							<div className="text-gray-400 text-sm mt-6 font-generalSans font-light">
								© 2024 Swift Haven Africa. All rights reserved.
							</div>
						</div>
					</div>

					{/* Right Column - Contact Form */}
					<div className="space-y-6">
						<form onSubmit={handleSubmit} className="space-y-4">
							<input
								type="text"
								name="name"
								placeholder="Name"
								required
								className="w-full px-4 py-3 bg-transparent border border-white/30 rounded-lg text-white placeholder-white focus:outline-none focus:border-white/60 transition-colors duration-200"
							/>
							<input
								type="email"
								name="email"
								placeholder="Email"
								required
								className="w-full px-4 py-3 bg-transparent border border-white/30 rounded-lg text-white placeholder-white focus:outline-none focus:border-white/60 transition-colors duration-200"
							/>
							<textarea
								name="message"
								placeholder="Leave a message"
								rows={4}
								required
								className="w-full px-4 py-3 bg-transparent border border-white/30 rounded-lg text-white placeholder-white focus:outline-none focus:border-white/60 transition-colors duration-200 resize-none"
							></textarea>

							<button
								type="submit"
								disabled={isSubmitting}
								className="w-full bg-white text-gray-900 font-light py-3 px-6 rounded-lg hover:scale-[1.01] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-generalSans"
							>
								{isSubmitting ? "Sending..." : "Send a message"}
							</button>
						</form>

						{/* Status Messages */}
						{submitStatus === "success" && (
							<div className="text-green-400 text-sm text-center font-generalSans font-light">
								Message sent successfully! We'll get back to you
								soon.
							</div>
						)}
						{submitStatus === "error" && (
							<div className="text-red-400 text-sm text-center font-generalSans font-light">
								Failed to send message. Please try again.
							</div>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contact;
